/**************************************************
 * Nombre:       Dialogo_Despacho
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {Delete} from "@mui/icons-material";
import logoRedondo from "../../Recursos/logo_redondo.svg"
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {guardarFecha} from "../../Servicios/Local/guardarFecha";
import Formulario_Foto_Productos from "../Formularios/Formulario_Foto_Productos";

const Dialogo_Foto_Producto = ({datos, cerrar, realizado}) => {
    const {
        props,
        obtenerEntidad,
    } = useFormulario({
        valoresDefecto: datos
    })
    const {Cargador, Avisos, iniciarCarga, nuevoAviso, terminar} = useCargador({
        logoRedondo: logoRedondo,
        funcionUno: realizado,
        funcionDos: cerrar,
        key: 'dos'
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga()

        let dox = await guardarDoc('fotos', entidad)
        if (dox.res) {
            await guardarFecha()
            terminar({aviso: 'Datos de coleccion subidos'})
        } else {
            terminar({aviso: 'No se subieron los datos, intentelo nuevamente', variante: 'error'})
        }

    }


    const borrar = async () => {
        await borrarDoc('reservas', datos.id)
        terminar({aviso: 'Registro borrado'})
    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Typography>Relacionar Prenda</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 1}}>
                <Formulario_Foto_Productos props={props} titulo={'Relacionar Prenda'}/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }

        </Grid>
    )

}
export default Dialogo_Foto_Producto